import React, { useEffect } from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { App as AntApp } from 'antd'
import router from '@/router/index'
import './main.css'
import './styles/theme.css'
import { useWebsiteStore } from '@/store/useWebsiteStore'
import ThemeProvider from '@/components/ThemeProvider'
import SpaceBackground from '@/components/SpaceBackground'

// 添加一个包装组件来一次性加载网站配置
const AppWrapper = () => {
  const { fetchConfig } = useWebsiteStore();

  // 只在应用启动时加载一次配置
  useEffect(() => {
    fetchConfig();
  }, [fetchConfig]);

  return (
    <>
      <SpaceBackground />
      <div style={{ position: 'relative', zIndex: 1 }}>
        <ThemeProvider>
          <AntApp>
            <RouterProvider router={router} />
          </AntApp>
        </ThemeProvider>
      </div>
    </>
  );
};
//React.StrictMode
ReactDOM.createRoot(document.getElementById('root')!).render(
    <AppWrapper />
)
